module.exports = __webpack_public_path__ + "img/link.87ebbd7e.png";